import { Link } from 'react-router-dom';
import { useI18n } from '@/hooks/useI18n';
import { routes } from '@/lib/routes';
import { pendingItems } from '../data';

/**
 * «Ожидают» — отдельная полоса от «Срочно» (NewsTicker / shell.urgent).
 * Не дублирует urgent; показывает ожидающие действия / статусы.
 */
export const PendingBand = () => {
  const { t } = useI18n();

  const items = pendingItems.map((key, index) => ({
    id: `pending-${index}`,
    title: t(key),
    href: routes.requests,
  }));

  const loop = [...items, ...items];

  return (
    <div className="quick-band">
      <strong>{t('pending.label')}</strong>
      <div className="quick-scroll">
        <div className="quick-inner">
          {loop.map((item, index) => (
            <Link
              key={`${item.id}-${index}`}
              to={item.href}
              className="v125-pending-item"
              aria-hidden={index >= items.length}
            >
              <b>{item.title}</b>
              <span>открыть</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
